import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { userCurrencySelector } from '@ezugi/bootstrap/src/store/selectors';
import { Icon } from '@ezugi/primitives/src';

import DefaultCurrencySvg from './icons/currency/default.svg';
import EuCurrencySvg from './icons/currency/eur.svg';
import KronaCurrencySvg from './icons/currency/krona.svg';
import PoundCurrencySvg from './icons/currency/pound.svg';
import ShekelCurrencySvg from './icons/currency/shekel.svg';
import UsdCurrencySvg from './icons/currency/usd.svg';
import YenCurrencySvg from './icons/currency/yen.svg';

const CurrencyIcon = ({ className }: { className?: string }) => {
  const currency = useSelector(userCurrencySelector);
  const svg = useMemo(() => {
    // Dollar currencies
    const dollarCurrencies = [
      'USD',
      'CAD',
      'MXN',
      'AUD',
      'CLP',
      'NZD',
      'ARS',
      'HKD',
      'SGD',
      'BBD',
      'BND',
      'BSD',
      'BZD',
      'FJD',
      'GYD',
      'JMD',
      'KYD',
      'LRD',
      'NAD',
      'SBD',
      'SRD',
      'TTD',
      'TVD',
      'XCD' ];

    // Pound currencies
    const poundCurrencies = [ 'GBP', 'CUP', 'EGP', 'FKP', 'GIP', 'IMP', 'JEP', 'LBP', 'SHP', 'SYP' ];

    // Yen currencies
    const yenCurrencies = [ 'JPY', 'CNY' ];

    // Krona currencies (Swedish Krona group)
    const kronaCurrencies = [ 'SEK', 'NOK', 'DKK' ];

    if (dollarCurrencies.includes(currency)) {
      return UsdCurrencySvg;
    } if (poundCurrencies.includes(currency)) {
      return PoundCurrencySvg;
    } if (yenCurrencies.includes(currency)) {
      return YenCurrencySvg;
    } if (currency === 'EUR') {
      return EuCurrencySvg;
    } if (kronaCurrencies.includes(currency)) {
      return KronaCurrencySvg;
    } if (currency === 'ILS') {
      return ShekelCurrencySvg;
    }
    return DefaultCurrencySvg;
  }, [ currency ]);

  return <Icon svg={svg} size={24} className={className} />;
};

export default CurrencyIcon;
